var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h2", [
        _vm._v("Please Login Before Migration /  在迁移数据前请务必登录")
      ]),
      _c(
        "b-jumbotron",
        { attrs: { variant: "danger", head: "Init Portal" } },
        [
          _vm._v("Init Portal\n\n    "),
          _c("br"),
          _c("br"),
          _c("b-button", { on: { click: _vm.updateFiles } }, [
            _vm._v("Update Files")
          ])
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _c("hr"),
      _c("p", [_vm._v("Admin Registration Portal")]),
      _c("Register", { on: { userRegister: _vm.createUser } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2202608d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2202608d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initPortalBeforeProduction.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2202608d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initPortalBeforeProduction.vue
// module chunks = 10